import Button from '@doordash/component-button'
import * as React from 'react'
import { connect } from 'react-redux'
import * as events from '../../../events'
import { Action } from 'redux'
import { VehicleType } from '../../../constants'
import {
  IdentityVerificationEvents,
  EventActions,
} from '../../../typeModules/events'
import { get } from 'lodash'

type PersonaButtonProps = {
  dasherId: string
  text: string
  application?: any
}

type ReduxProps = {
  trackIdentityVerificationSteps?: (data: IdentityVerificationEvents) => Action
}

const PERSONA_URL = 'https://doordash.withpersona.com/verify?template-id='
const REFERENCE_URL = '&reference-id='

const TemplateIds = {
  citizen: {
    [VehicleType.Bicycle]: 'tmpl_5kiwLqviWuF2bxBBWrCs1CRG',
    [VehicleType.Scooter]: 'tmpl_eyXNaAszKds5xXJ8frpku6F7',
    [VehicleType.Motorcycle]: 'tmpl_gQVX5gND2A1tBZyC4f4NoU3k',
    [VehicleType.Car]: 'tmpl_s7V45JLyD7aMqfW6uCzeDtga',
  },
  noCitizen: {
    [VehicleType.Bicycle]: 'tmpl_9wEfN7KzdZ6fG2XLWHNUK7tt',
    [VehicleType.Scooter]: 'tmpl_BTid9QkFYWhy5fmWhnYa9Qzt',
    [VehicleType.Motorcycle]: 'tmpl_gkvJqFyA9huDf47NzUhaiwp3',
    [VehicleType.Car]: 'tmpl_yj4kMvPtjRFa82stZFqbaJDx',
  },
}
const defaultVehicleType = VehicleType.Bicycle
const determineTemplateId = application => {
  const { vehicleType, citizenshipCountryShortname, country } = application
  const citizenship = citizenshipCountryShortname === country
  return citizenship
    ? TemplateIds.citizen[vehicleType] ||
        TemplateIds.citizen[defaultVehicleType]
    : TemplateIds.noCitizen[vehicleType] ||
        TemplateIds.noCitizen[defaultVehicleType]
}

export const PersonaButton: React.FC<PersonaButtonProps & ReduxProps> = ({
  dasherId,
  text,
  application,
  trackIdentityVerificationSteps,
}) => {
  const templateId = determineTemplateId(application)
  const email = get(application, 'email', '')
  const trackEvent = () => {
    trackIdentityVerificationSteps({
      email,
      step: 'start',
      status: EventActions.Rendered,
    })
  }

  return (
    <Button
      tag={'a'}
      href={`${PERSONA_URL}${templateId}${REFERENCE_URL}${dasherId}`}
      onClick={trackEvent}
    >
      {text}
    </Button>
  )
}

const mapStateToProps = state => ({
  application: state.application,
})

const mapDispatchToProps = {
  trackIdentityVerificationSteps: events.trackIdentityVerificationSteps,
}

export default connect(mapStateToProps, mapDispatchToProps)(PersonaButton)
